<template>
  <div v-if="broker != null && settings != null">

    <div class="text-lg">Notification Settings</div>
    
    <div class="my-8 w-1/2">
      <label class="label-standard">
        When sending application to clients via email, 
        by default, send a SMS to their mobile phone as well.
      </label>

      <div class="mt-1 text-gray-700 text-sm">
        You can always change this on the submit page.
      </div>

      <div class="form-line">
        <div class="mt-2 flex items-center">
          <input type="radio" name="input-sms-client-when-broker-submits" v-model="settings.sms_client_when_broker_submits" :value="1" id="input-sms-client-when-broker-submits-yes" />
          <label for="input-sms-client-when-broker-submits-yes" class="ml-2 mr-8 text-sm">Yes</label>
        
          <input type="radio" name="input-sms-client-when-broker-submits" v-model="settings.sms_client_when_broker_submits" :value="0" id="input-sms-client-when-broker-submits-no" />
          <label for="input-sms-client-when-broker-submits-no" class="ml-2 text-sm">No</label>
        </div>
      </div>

      <div class="label-line label-standard">
        When client sends back the application form via email, 
        by default, send me a SMS as well.
      </div>

      <div class="mt-1 text-gray-700 text-sm">
        You can always change this on the submit page.
      </div>

      <div class="form-line">
        <div class="mt-2 flex items-center">
          <input type="radio" name="input-sms-broker-when-client-submits" v-model="settings.sms_broker_when_client_submits" :value="1" id="input-sms-broker-when-client-submits-yes" />
          <label for="input-sms-broker-when-client-submits-yes" class="ml-2 mr-8 text-sm">Yes</label>
        
          <input type="radio" name="input-sms-broker-when-client-submits" v-model="settings.sms_broker_when_client_submits" :value="0" id="input-sms-broker-when-client-submits-no" />
          <label for="input-sms-broker-when-client-submits-no" class="ml-2 text-sm">No</label>
        </div>
      </div>



      <div class="label-line label-standard">
        Email client on their birthday
      </div>

      <div class="mt-1 text-gray-700 text-sm">
        3 days before a client's birthday (i.e. primary applicant's birthday), we will send you an email notifying you 
        and you can choose to send an email with a custom message.
      </div>

      <div class="form-line">
        <div class="mt-2 flex items-center">
          <input type="radio" name="input-email-on-birthday" v-model="settings.email_on_client_birthday" :value="1" id="input-email-on-birthday-yes" />
          <label for="input-email-on-birthday-yes" class="ml-2 mr-8 text-sm">Yes</label>
        
          <input type="radio" name="input-email-on-birthday" v-model="settings.email_on_client_birthday" :value="0" id="input-email-on-birthday-no" />
          <label for="input-email-on-birthday-no" class="ml-2 text-sm">No</label>
        </div>
      </div>




      <div class="label-line label-standard">
        Email client 4 weeks before the property loan's fixed rate ends
      </div>

      <div class="mt-1 text-gray-700 text-sm">
        4 weeks before the fixed rate ends for a client's property loan, we will send you an email notifying you 
        and you can choose to send an email with a custom message.
      </div>

      <div class="form-line">
        <div class="mt-2 flex items-center">
          <input type="radio" name="input-email-on-fixed-rate-expiry" v-model="settings.email_before_fixed_rate_ends" :value="1" id="input-email-on-fixed-rate-expiry-yes" />
          <label for="input-email-on-fixed-rate-expiry-yes" class="ml-2 mr-8 text-sm">Yes</label>
        
          <input type="radio" name="input-email-on-fixed-rate-expiry" v-model="settings.email_before_fixed_rate_ends" :value="0" id="input-email-on-fixed-rate-expiry-no" />
          <label for="input-email-on-fixed-rate-expiry-no" class="ml-2 text-sm">No</label>
        </div>
      </div>




      <div class="label-line label-standard">
        Receive {{ getAppName }} report via email
      </div>

      <div class="mt-1 text-gray-700 text-sm">
        Receive the latest stats and information on how your brokign is going on {{ getAppName }}
      </div>

      <div class="form-line">
        <div class="mt-2 flex items-center">
          <input type="radio" name="input-report-frequency" v-model="reportFrequency" value="weekly" id="input-report-frequency-weekly" />
          <label for="input-report-frequency-weekly" class="ml-2 mr-8 text-sm">Weekly</label>

          <input type="radio" name="input-report-frequency" v-model="reportFrequency" value="fortnightly" id="input-report-frequency-fortnightly" />
          <label for="input-report-frequency-fortnightly" class="ml-2 mr-8 text-sm">Fortnightly</label>

          <input type="radio" name="input-report-frequency" v-model="reportFrequency" value="monthly" id="input-report-frequency-monthly" />
          <label for="input-report-frequency-monthly" class="ml-2 mr-8 text-sm">Monthly</label>
        
          <input type="radio" name="input-report-frequency" v-model="reportFrequency" value="never" id="input-report-frequency-never" />
          <label for="input-report-frequency-never" class="ml-2 text-sm">No thanks</label>
        </div>
      </div>

      <div class="mt-12">
        <SubmitButton2 :onClick="submit" :loading="loading" />
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  
  export default {

    components: {
      SubmitButton2
    },

    data () {
      return {
        loading        : false,
        broker         : null,
        settings       : null,
        reportFrequency: 'weekly'
      }
    },

    created() {
      this.broker          = _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker)
      this.reportFrequency = this.broker.report_frequency

      this.apiGet({
        brokerId : this.broker.id        
      }, 'broker/notification-settings', (settings) => {
        this.settings = settings
      })
    },

    methods : {
      submit() {
        this.loading = true
        this.apiPost({
          settings       : this.settings,
          reportFrequency: this.reportFrequency
        }, 'broker/notification-settings', () => {
          this.loading = false
          EventBus.$emit('notification-event', {
            'type'   : 'success', 
            'message': 'Saved successfully.'
          }) 
        })
      }
    },
  }
</script>